module.exports = __webpack_public_path__ + "img/error-404.a62f647f.png";